import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const IconAvailability = ({ availability, className, ...iconProps }) => {
  return (
    <Icon
      {...iconProps}
      className={classNames(
        className,
        `status-${availability.toLocaleLowerCase()}`,
      )}
    />
  );
};

IconAvailability.propTypes = {
  availability: PropTypes.oneOf([
    'online',
    'available',
    'logout',
    'aged',
    'offline',
    'unknown',
    'recent',
  ]).isRequired,
  ...Icon.propTypes,
};

export default IconAvailability;
